import styled from 'styled-components';
import { usePreferences } from '@/hooks/usePreferences';
import type { FeedOrderKey } from '@/core/models/preferences';

const Control = styled.label`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 0;
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textMuted};
  select {
    min-height: 40px;
    max-width: 100%;
    padding: 6px 10px;
    font: inherit;
    color: ${({ theme }) => theme.color.textPrimary};
    background: ${({ theme }) => theme.color.surface};
    border: 1px solid ${({ theme }) => theme.color.hairSoft};
    border-radius: ${({ theme }) => theme.radius.md};
  }
`;

export function FeedOrderControl({ compact = false }: { compact?: boolean }) {
  const { prefs, setPreference } = usePreferences();
  return (
    <Control>
      {!compact && 'Feed order'}
      <select
        aria-label="Feed order"
        value={prefs.feedOrder}
        onChange={(e) => void setPreference('feedOrder', e.target.value as FeedOrderKey)}
      >
        <option value="default">Tab default</option>
        <option value="newest">Newest</option>
        <option value="most-liked">Most cherished</option>
        <option value="oldest">Oldest</option>
      </select>
    </Control>
  );
}
